<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("Download") }}
      </p>
    </div>
    <div class="modal-card-body">
      <b-field :label="$t('Image')">
        <div class="notification">
	  <b-field :label="$t('Available sizes')">
	    <b-field>
	      <p v-for="source, key, index in imageSources" class="control">
		<b-button
		  tag="a"
      target="_blank"
		  :href="source"
		  style="min-width: 3rem"
		  download	  
		>
		  {{ key }}
		</b-button>
	      </p>
	    </b-field>
	  </b-field>
	</div>
      </b-field>
      <b-field :label="$t('Text')">
        <div class="notification">
          <b-field :label="xml.label">
            <b-button
              tag="a"
              :href="xml.source"
              icon-left="download"
              style="min-width: 3rem"
            >
              {{ $t("Download") }}
            </b-button>
          </b-field>
          <b-field>
            <b-field :label="txt.label">
              <b-button
                tag="a"
                :href="txt.data"
                icon-left="download"
                :download="txt.filename"
                :loading="!txt.data"
              >
                {{ $t("Download") }}
              </b-button>
            </b-field>
          </b-field>
        </div>
      </b-field>
    </div>
    <div class="modal-card-foot">
      <div class="is-flex" style="width: 100%">
        <b-button
          @click="$parent.close"
          type="is-primary"
          style="margin-left: auto"
        >
          {{ $t("Close") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Level from "@/components/Level.vue";

import imageMixin from "@/mixins/image.js";
import contentMixin from "@/mixins/content.js";

import api from "@/api";

export default {
  mixins: [imageMixin, contentMixin],
  components: {
    Level,
  },
  props: {
    imageKey: {
      type: String,
      required: true,
    },
    contentKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      txt: {
        label: "TXT",
        data: null,
        filename: `${this.contentKey}.txt`,
      },
    };
  },
  computed: {
    imageSources() {
      return {
        S: this.getScaledSource(this.imageKey, { width: 480 }),
        M: this.getScaledSource(this.imageKey, { width: 720 }),
        L: this.getScaledSource(this.imageKey, { width: 960 }),
        XL: this.getImageSource(this.imageKey),
      };
    },
    xml() {
      return {
        label: "Prima Page Content XML",
        source: this.getContentXMLSource(this.contentKey),
      };
    },
  },
  async mounted() {
    await this.loadPageContentJson(this.contentKey);
  },
  // FIXTHIS: avoid duplication of code in DetailContentDownload.vue
  methods: {
    async loadPageContentJson(key) {
      var data = await this.api.fetchContent(key);
      const txt = this.convertContentToText(data.PcGts.Page);
      const blob = new Blob([txt], { type: "text/plain" });
      this.txt.data = URL.createObjectURL(blob);
    },
    convertContentToText(data) {
      return (data.elements || [])
        .map((content) => {
          return (content.elements || [])
            .map((item) => {
              return this.extractText(item);
            })
            .join("\r\n");
        })
        .join("\r\n\r\n");
    },
    extractText(item) {
      const clean = (s) =>
        typeof s !== "string" ? "" : s.trim().replace(/¬$/, "\u2010");
      return item.elements && item.elements[0]
        ? clean(item.elements[0].text)
        : "";
    },
  },
};
</script>
